import React from 'react';
import { func, string, oneOfType, oneOf, number, bool } from 'prop-types';
import MuiChip from '@mui/material/Chip';
import { ChipWrapper } from './Chip.styles';
import { Icons } from '../..';
const CrossIcon = Icons.cross;
export const Chip = _ref => {
  let {
    label,
    id,
    action,
    actionType,
    isDisabled
  } = _ref;
  return /*#__PURE__*/React.createElement(ChipWrapper, null, actionType === 'deletable' ? /*#__PURE__*/React.createElement(MuiChip, {
    label: label,
    "data-test-id": "chip",
    disabled: isDisabled,
    onDelete: action ? () => action(id) : undefined,
    deleteIcon: /*#__PURE__*/React.createElement(CrossIcon, {
      "aria-label": "delete"
    })
  }) : /*#__PURE__*/React.createElement(MuiChip, {
    label: label,
    "data-test-id": "chip",
    disabled: isDisabled,
    onClick: action ? () => action(id) : undefined,
    disableRipple: true
  }));
};
Chip.propTypes = {
  label: string.isRequired,
  actionType: oneOf(['clickable', 'deletable']),
  action: func,
  id: oneOfType([string, number]),
  isDisabled: bool
};
Chip.defaultProps = {
  actionType: 'deletable',
  action: undefined,
  id: '',
  isDisabled: false
};